import { render, staticRenderFns } from "./Model6.vue?vue&type=template&id=238f170f&scoped=true"
import script from "./Model6.vue?vue&type=script&lang=js"
export * from "./Model6.vue?vue&type=script&lang=js"
import style0 from "./Model6.vue?vue&type=style&index=0&id=238f170f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238f170f",
  null
  
)

export default component.exports